import React, { Component } from 'react'
// eslint-disable-next-line
import { Link, Navigate, Route, Routes } from 'react-router-dom'
import DataTable from 'react-data-table-component';
import { connect } from "react-redux"
import { increment, decrement } from "../../features/counter/counterSlice"
import { setLoggedIn } from "../../features/account/loginSlice"
import { setAccount } from "../../features/account/accountSlice"
import { setCompany } from "../../features/account/companySlice"
import axios from "axios";
import qs from 'qs';
import Swal from 'sweetalert2'
import { hidePreloader, showPreloader, priceFormat } from '../../library/helper';
import { withTranslation } from 'react-i18next';

import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";

export class Reduction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tableColumn: [],
            tableData: [],
            tableFiltered: [],
            tableFilter: "",
            tableResetPagination: false,
            revenueUnit: "",
            isDummy: false,
            selectedRow: null,
        }
    }

    makeDummyRows = () => {
        const today = new Date();
        const rows = Array.from({ length: 5 }, (_, i) => {
            const d = new Date(today);
            d.setMonth(d.getMonth() - i);
            const iso = d.toISOString().slice(0, 10);
            const bau = 1200 + i * 100;          // “before” baseline
            const actual = 900 + i * 90;         // “after” actual
            return {
                reduction_uuid: `dummy-${i + 1}`,
                reduction_date: iso,
                category_name: `Category ${i + 1}`,
                reduction_bau: bau,
                reduction_actual: actual,
            };
        });
        return rows;
    };

    isFreemiumUser = () => {
        const a = this.props.account || {};
        return (
            a.client_subscription === 1
        );
    };

    componentDidMount = async () => {
        showPreloader();

        const data = {};
        let tempRevenueUnit = "";

        // fetch settings (to get revenue unit)
        try {
            const optionsSetting = {
                withCredentials: true,
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(data),
                url: `${process.env.REACT_APP_BASE_SERVER}/account/setting/read`
            };
            const responseSetting = await axios(optionsSetting);
            if (responseSetting.data.success) {
                if (responseSetting.data?.data?.[0]?.client_revenue_unit == 1) {
                    tempRevenueUnit = "IDR mn";
                } else {
                    tempRevenueUnit = "USD k";
                }
            }
        } catch (e) {
            // ignore and keep default
        }

        // fetch reductions
        let record = [];
        try {
            const options = {
                withCredentials: true,
                method: 'POST',
                headers: { 'content-type': 'application/x-www-form-urlencoded' },
                data: qs.stringify(data),
                url: `${process.env.REACT_APP_BASE_SERVER}/reduction/get_all`
            };
            const response = await axios(options);
            if (response.data.success) {
                record = response.data.data || [];
            }
        } catch (e) {
            record = [];
        }

        // if subscription is 1 and there is no data, insert dummy rows
        let useDummy = false;
        if (this.isFreemiumUser() && record.length === 0) {
            record = this.makeDummyRows();
            useDummy = true;
        }

        const columns = [
            {
                name: 'Entity',
                selector: row => row.client_name || '—',
                sortable: true,
                filterable: true,
            },
            {
                name: this.props.t('emission.table.label1'),
                selector: row => row.reduction_date,
                sortable: true,
                filterable: true,
            },
            {
                name: this.props.t('emission.table.label3'),
                selector: row => row.category_name,
                sortable: true,
                filterable: true,
            },
            {
                name: 'RECs Number',
                selector: row => row.cert_number || '—',
                sortable: true,
                filterable: true,
            },
            {
                name: 'Reduction Amount',
                selector: row => `${priceFormat(parseFloat(row.reduction_actual_amount || 0).toFixed(2))} kWh`,
                sortable: true,
                filterable: true,
            },
            {
                name: 'REC EF (tCO₂e/kWh)',
                selector: row => parseFloat(row.cert_emission_factor || 0).toString(),
                sortable: true,
                filterable: true,
            },
            {
                name: 'Total Emission (tCO₂e)',
                selector: row => priceFormat(parseFloat(row.reduction_actual || 0).toFixed(4)),
                sortable: true,
                filterable: true,
            },
            {
                name: this.props.t('emission.table.label6'),
                selector: row => (
                    <div className="d-flex align-items-center gap-2">
                        <Tooltip title="View">
                            <IconButton
                                size="small"
                                color="info"
                                onClick={() => this.setState({ selectedRow: row })}
                            >
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Edit">
                            <IconButton
                                size="small"
                                color="info"
                                component={Link}
                                to={`/reduction/update/${row.reduction_uuid}`}
                                disabled={String(row.reduction_uuid).startsWith('dummy-')}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <IconButton
                                size="small"
                                color="warning"
                                onClick={() => this.onDelete(row.reduction_uuid)}
                                disabled={String(row.reduction_uuid).startsWith('dummy-')}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    </div>
                ),
                sortable: true,
                filterable: true,
                width: "210px",
            },
        ];

        this.setState({
            tableColumn: columns,
            tableData: record,
            tableFiltered: record,
            revenueUnit: tempRevenueUnit,
            isDummy: useDummy,
        });

        hidePreloader();
    }

    onFilter = async (e) => {
        const val = e.target.value || "";
        let baseData = this.state.tableData;
        if (val.trim() !== "") {
            const filteredData = baseData.filter(
                item => (item.category_name || "").toLowerCase().includes(val.toLowerCase())
            );
            this.setState({
                tableFilter: val,
                tableFiltered: filteredData,
            });
        } else {
            this.setState({
                tableFilter: "",
                tableFiltered: baseData,
            });
        }
    }

    onClear = async () => {
        if (this.state.tableFilter !== "") {
            this.setState({
                tableFilter: "",
                tableFiltered: this.state.tableData,
            });
        }
    }

    onDeleteCall = async (data) => {
        const options = {
            withCredentials: true,
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            data: qs.stringify(data),
            url: `${process.env.REACT_APP_BASE_SERVER}/reduction/delete`
        };
        const response = await axios(options);
        return !!response.data.success;
    }

    onDelete = async (id) => {
        if (String(id).startsWith('dummy-')) return; // do nothing for demo rows

        let invalidData = true;
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                const ok = await this.onDeleteCall({ id });
                invalidData = !ok;

                if (invalidData) {
                    Swal.fire({
                        title: '',
                        html: '<p>Cannot delete data, please try again later</p>',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    })
                } else {
                    Swal.fire({
                        title: 'Deleted',
                        text: "Your data has been deleted.",
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: 'Ok'
                    }).then((r) => {
                        if (r.isConfirmed) {
                            window.location.reload();
                        }
                    })
                }
            }
        })
    }

    render() {
        const { tableColumn, tableFilter, tableFiltered, isDummy, selectedRow } = this.state;
        const paginationComponentOptions = {
            rowsPerPageText: this.props.t('table.paginationResult'),
            rangeSeparatorText: this.props.t('table.paginationResultPage'),
        };

        return (
            <div className="page-content">
                <div className="container-fluid">

                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <h4 className="mb-sm-0">Renewable Energy Certificate</h4>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5 className="card-title mb-0">{this.props.t('general.read')}</h5>
                                    <br /><br />
                                    <Link to={'/reduction/create'} className="btn btn-success">{this.props.t('general.btnCreate')}</Link>
                                    <div className="col-lg-4" style={{ float: "right" }}>
                                        <div className="input-group">
                                            <span className="input-group-text" id="search"><i className="ri-search-line"></i></span>
                                            <input
                                                value={tableFilter}
                                                onChange={e => this.onFilter(e)}
                                                type="text"
                                                className="form-control"
                                                placeholder={this.props.t('table.search')}
                                                aria-describedby="search"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="card-body" style={{ position: 'relative' }}>
                                    {isDummy && (
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: "50%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                textAlign: "center",
                                                fontSize: "3rem",
                                                fontWeight: "bold",
                                                color: "rgba(0,0,0,0.2)",
                                                pointerEvents: "none",
                                                userSelect: "none",
                                                zIndex: 3,
                                            }}
                                        >
                                            {this.props.t("menu.callToUpgrade2")}
                                        </div>
                                    )}
                                    <div style={{ position: 'relative', zIndex: 2 }}>
                                        <DataTable
                                            columns={tableColumn}
                                            data={tableFiltered}
                                            noDataComponent={this.props.t('table.empty')}
                                            pagination
                                            paginationComponentOptions={paginationComponentOptions}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Detail Modal */}
                {selectedRow && (
                    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">REC Detail</h5>
                                    <button type="button" className="btn-close" onClick={() => this.setState({ selectedRow: null })} />
                                </div>
                                <div className="modal-body">
                                    <table className="table table-bordered">
                                        <tbody>
                                            <tr><th style={{ width: '40%' }}>Purchased Date</th><td>{selectedRow.reduction_date}</td></tr>
                                            <tr><th>Action Category</th><td>{selectedRow.category_name}</td></tr>
                                            <tr><th>Imported Electricity Grid</th><td>{selectedRow.emission_name || '—'}</td></tr>
                                            <tr><th>Imported Electricity Amount (kWh)</th><td>{priceFormat(parseFloat(selectedRow.reduction_bau_amount || 0).toFixed(2))}</td></tr>
                                            <tr><th>REC ID/Number/Unit</th><td>{selectedRow.cert_number || '—'}</td></tr>
                                            <tr><th>REC Purchased Amount (MWh)</th><td>{priceFormat((parseFloat(selectedRow.reduction_actual_amount || 0) / 1000).toFixed(0))}</td></tr>
                                            <tr><th>REC Purchased Amount (kWh)</th><td>{priceFormat(parseFloat(selectedRow.reduction_actual_amount || 0).toFixed(2))}</td></tr>
                                            <tr><th>REC Emissions Factor (tCO₂e/kWh)</th><td>{parseFloat(selectedRow.cert_emission_factor || 0).toFixed(6)}</td></tr>
                                            <tr><th>Total Emission (tCO₂e)</th><td>{priceFormat(parseFloat(selectedRow.reduction_actual || 0).toFixed(4))}</td></tr>
                                            {selectedRow.remarks && <tr><th>Remarks</th><td>{selectedRow.remarks}</td></tr>}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => this.setState({ selectedRow: null })}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    count: state.counter.value,
    loggedIn: state.loggedIn.value,
    account: state.account.value,
    company: state.company.value,
});

const mapDispatchToProps = { increment, decrement, setLoggedIn, setAccount, setCompany };

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Reduction));
